import { fg } from '@atlaskit/platform-feature-flags/fg';

const PEOPLE_DATA_PROVIDERS = ['workday', 'google', 'microsoft'] as const;

export type PeopleDataProvider = (typeof PEOPLE_DATA_PROVIDERS)[number];

export const getPeopleDataProviders = (value: unknown): PeopleDataProvider[] => {
	if (!fg('kd_chat_people_data_attribution') || !Array.isArray(value)) {
		return [];
	}

	return PEOPLE_DATA_PROVIDERS.filter((provider) => value.includes(provider));
};

export const getPeopleDataProviderAttributes = (
	peopleDataProviders: readonly PeopleDataProvider[],
): { peopleDataProviders?: readonly PeopleDataProvider[] } =>
	peopleDataProviders.length > 0 ? { peopleDataProviders } : {};
